// extracted by mini-css-extract-plugin
export default {"PageAdpx":"PageAdpx_PageAdpx__9hM94","PartieGauche":"PageAdpx_PartieGauche__dxR4i","MenuAdpx":"PageAdpx_MenuAdpx__CWjry"};